import React from "react";
import StockItemCard from "./StockItemCard";
import CarItemList from "./StockItemList";

function renderStockCards(stock) {
  return stock.webVisible && stock.condition !== "NEW" && stock.megaDealers === "HAVAL" ? (
    <StockItemCard key={stock._id} stock={stock} />
  ) : null;
}

function renderStockList(stock) {
  return stock.webVisible && stock.condition !== "NEW" && stock.megaDealers === "HAVAL" ? (
    <CarItemList key={stock._id} stock={stock} />
  ) : null;
}

const StockList = (props) => {
  if (props.displayType === "cards")
    return <div>{props.stocklist.map((stock) => renderStockCards(stock))}</div>;
  else if (props.displayType === "list")
    return <div>{props.stocklist.map((stock) => renderStockList(stock))}</div>;
  console.log("props.stocklist");
};

export default StockList;
